const initialState = {
    mode: "single"
}

const versionReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_MODE": {
            return {
                ...state,
                mode: action.data
            }
        }
        default: {
            return state
        }
    }
}

export default versionReducer;